import { render, staticRenderFns } from "./addPurchase.vue?vue&type=template&id=4094ab4e&scoped=true"
import script from "./addPurchase.vue?vue&type=script&lang=js"
export * from "./addPurchase.vue?vue&type=script&lang=js"
import style0 from "./addPurchase.vue?vue&type=style&index=0&id=4094ab4e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4094ab4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4094ab4e')) {
      api.createRecord('4094ab4e', component.options)
    } else {
      api.reload('4094ab4e', component.options)
    }
    module.hot.accept("./addPurchase.vue?vue&type=template&id=4094ab4e&scoped=true", function () {
      api.rerender('4094ab4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantInfo/addPurchase.vue"
export default component.exports